import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from '@templatean/shared/hooks'
import App from './App'
import './styles/index.css'

// Initialize Office.js
Office.onReady((info) => {
  if (info.host === Office.HostType.Word) {
    const root = ReactDOM.createRoot(document.getElementById('root')!)
    root.render(
      <React.StrictMode>
        <AuthProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AuthProvider>
      </React.StrictMode>
    )
  }
})